import { QueryParams, TAG_TYPES } from 'types';
import { baseApi } from './index';
import { RoleRecord as T } from 'types/permission.types';
import { getQueryParams } from 'utils';

const urlEndpoint = `${process.env.REACT_APP_BASE_URL}/roles`;
const tagType = TAG_TYPES.Role;

const RolesApiService = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getAllRoles: builder.query<
      {
        data: {
          rows: T[];
          count: number;
        };
        success: boolean;
        message: string;
      },
      { query: QueryParams }
    >({
      query: (params) => {
        const query = getQueryParams(params?.query);
        if (query === '') return { url: urlEndpoint, method: 'GET' };
        return {
          url: `${urlEndpoint}?${query}`,
          method: 'GET',
        };
      },
      providesTags: (result) => {
        return result
          ? [...(result?.data?.rows || []).map(({ id }) => ({ type: tagType, id })), { type: tagType, id: 'LIST' }]
          : [{ type: tagType, id: 'LIST' }];
      },
    }),

    getRolesById: builder.query<{ data: T }, string>({
      query: (id) => ({
        url: `${urlEndpoint}/${id}`,
        method: 'GET',
      }),
      providesTags: (result, error, id) => [{ type: tagType, id }],
    }),
    createRole: builder.mutation<{ data: T }, { data: T }>({
      query: ({ data }) => ({
        url: urlEndpoint,
        method: 'POST',
        data: {
          ...data,
        },
      }),
      invalidatesTags: [{ type: tagType, id: 'LIST' }],
    }),
    updateRole: builder.mutation<{ data: T }, { id: string; data: T }>({
      query: ({ id, data }) => ({
        url: `${urlEndpoint}/${id}`,
        method: 'PUT',
        data: {
          ...data,
        },
      }),
      invalidatesTags: (result, error, { id }) => [
        { type: tagType, id },
        { type: tagType, id: 'LIST' },
      ],
    }),
    deleteRole: builder.mutation<{ data: T }, string>({
      query: (id) => ({
        url: `${urlEndpoint}/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: (result, error, id) => [
        { type: tagType, id },
        { type: tagType, id: 'LIST' },
      ],
    }),
  }),
});

export const {
  useGetAllRolesQuery,
  useGetRolesByIdQuery,
  useLazyGetRolesByIdQuery,
  useCreateRoleMutation,
  useUpdateRoleMutation,
  useDeleteRoleMutation,
} = RolesApiService;
